// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ParkingSpaceFormController from "./parking_space_form_controller"
application.register("parking-space-form", ParkingSpaceFormController)
import FormAutofocusController from "./form_autofocus_controller"
application.register("form-autofocus", FormAutofocusController)
import occupancyChartController from"./occupancy_chart_controller"
application.register("occupancy-chart", occupancyChartController)
